import type {
  PermissionType,
  PersistedPermissionState
} from './types'

const STORAGE_KEY = 'emissary_permissions_state'

export const getPersistedState = (): PersistedPermissionState => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}

export const setPersistedState = (state: PersistedPermissionState): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
}

export const updatePermissionState = (
  type: PermissionType,
  updates: Partial<PersistedPermissionState[string]>
): void => {
  const current = getPersistedState()
  current[type] = { ...current[type], ...updates }
  setPersistedState(current)
}

export const getPermissionState = (
  type: PermissionType
): PersistedPermissionState[string] | null => {
  return getPersistedState()[type] || null
}

export const hasAskedBefore = (type: PermissionType): boolean => {
  const state = getPermissionState(type)
  return !!state?.askedAt
}

export const shouldShowDeniedDialog = (type: PermissionType): boolean => {
  const state = getPermissionState(type)
  return state?.lastKnownState === 'denied' && !state?.deniedDialogShown
}

export const markDeniedDialogShown = (type: PermissionType): void => {
  updatePermissionState(type, { deniedDialogShown: true })
}
